import { RouteRecordRaw } from 'vue-router';

export default (): Array<RouteRecordRaw> => {
    return [
        {
            path: '/home',
            name: 'home',
            component: () => import("./views/home.vue"),
            meta: {
                hasBar: true,
                closeAppModal: true
            }
        },
        {
            path: '/home/:identifier',
            name: 'home_identifier',
            component: () => import("./views/home.vue"),
            meta: {
                hasBar: true,
            }
        },
        {
            path: '/datiPersonali',
            name: 'datiPersonali',
            component: () => import("./views/datiPersonali.vue"),
        },
        {
            path: '/walletTransactions',
            name: 'walletTransactions',
            component: () => import("./views/walletTransactions.vue"),
        },
        {
            path: '/walletTransactions/:identifier',
            name: 'walletTransactions_identifier',
            component: () => import("./views/walletTransactions.vue"),
        },
        {
            path: '/commissions',
            name: 'commissions',
            component: () => import("./views/commissions.vue"),
        },
        {
            path: '/commissions/:identifier',
            name: 'commissions_identifier',
            component: () => import("./views/commissions.vue"),
        },
    ];
};